// Configuration des liens externes et constantes de l'application

export const EXTERNAL_LINKS = {
  // Discord - Remplacer par votre vrai lien Discord quand vous l'aurez
  DISCORD: "https://discord.gg/2MwXHc2sQF",
  
  // Autres liens externes (à ajouter si nécessaire)
  // TWITTER: "https://twitter.com/votre-compte",
  // YOUTUBE: "https://youtube.com/votre-chaine",
  // GITHUB: "https://github.com/votre-repo",
};

// Autres constantes de l'application
export const APP_CONFIG = {
  NAME: "Mon Premier Jeu",
  VERSION: "1.0.0",
  // Autres configurations...
};

// Configuration des contacts
export const CONTACT_INFO = {
  EMAIL: "myke38@monpremierjeu.fr",
};

// Informations légales de l'entreprise
export const LEGAL_INFO = {
  COMPANY_NAME: "MH Production",
  LEGAL_FORM: "SASU", // À adapter selon votre statut
  ADDRESS: {
    STREET: "112 chemin de bois claret", // À compléter
    POSTAL_CODE: "38190", // À compléter
    CITY: "Bernin", // À compléter
    COUNTRY: "France"
  },
  SIRET: "794 297 697", // À compléter
  RCS: "[Numéro RCS]", // À compléter si applicable
  TVA: "[Numéro TVA intracommunautaire]", // À compléter si applicable
  PHONE: "[Numéro de téléphone]", // À compléter
  CAPITAL: "1200€", // À compléter si applicable
  
  // Informations de l'hébergeur
  HOSTING: {
    PROVIDER: "IONOS SARL",
    ADDRESS: "7, place de la Gare, BP 70109, 57200 Sarreguemines Cedex, France",
    PHONE: "0970 808 911",
    EMAIL: "info@ionos.fr",
    LEGAL_FORM: "Société à responsabilité limitée (SARL)",
    CAPITAL: "100 000 €",
    SIRET: "431 303 775 00016",
    RCS: "Sarreguemines B 431 303 775",
    TVA: "FR13431303775"
  },
  
  // Directeur de publication
  PUBLICATION_DIRECTOR: "[Nom du directeur de publication]" // À compléter
};

// Configuration des prix du Pass Codeur
export const PASS_CODEUR_PRICING = {
  // Prix actuel (en euros)
  CURRENT_PRICE: 4.99,
  // Prix barré (prix original)
  ORIGINAL_PRICE: 49.99,
  // Devise
  CURRENCY: 'eur',
  // Prix en centimes pour Stripe
  get CURRENT_PRICE_CENTS() {
    return Math.round(this.CURRENT_PRICE * 100);
  },
  // Pourcentage de réduction
  get DISCOUNT_PERCENTAGE() {
    return Math.round((1 - this.CURRENT_PRICE / this.ORIGINAL_PRICE) * 100);
  }
};